"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "roccabernarda": {
    "2ecce468": [{
      "hkey": "c821a748",
      "slug": "roccabernarda",
      "name": "Roccabernarda",
      "primary": true,
      "skipSearch": false
    }],
    "contrade-caprara": [{
      "hkey": "c821a748",
      "slug": "roccabernarda",
      "name": "Roccabernarda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7946db4e": [{
      "hkey": "c821a748",
      "slug": "roccabernarda",
      "name": "Roccabernarda",
      "primary": true,
      "skipSearch": false
    }],
    "lenze": [{
      "hkey": "c821a748",
      "slug": "roccabernarda",
      "name": "Roccabernarda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "eeb6daa2": [{
      "hkey": "c821a748",
      "slug": "roccabernarda",
      "name": "Roccabernarda",
      "primary": true,
      "skipSearch": false
    }],
    "salinella": [{
      "hkey": "c821a748",
      "slug": "roccabernarda",
      "name": "Roccabernarda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b62499a5": [{
      "hkey": "c821a748",
      "slug": "roccabernarda",
      "name": "Roccabernarda",
      "primary": true,
      "skipSearch": false
    }],
    "termine-grosso": [{
      "hkey": "c821a748",
      "slug": "roccabernarda",
      "name": "Roccabernarda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;